<template>
    <el-select v-model="val" @change="handleChange" placeholder="请选择国家">
        <el-option v-for="item in options" :key="item.label" :label="item.value" :value="item.label"> </el-option>
    </el-select>
</template>

<script>
import { getCountryList } from "@/api/common";
export default {
    props: {
        value: {
            type: String | Number,
            default: "",
        },
    },
    data() {
        return {
            val: "",
            options: [],
        };
    },
    watch: {
        value: {
            handler(val) {
                this.val = val;
            },
            immediate: true,
        },
    },
    mounted() {
        this.search();
    },
    methods: {
        search() {
            getCountryList().then(({ code, result, message }) => {
                if (code == 200) {
                    this.options = result || [];
                } else {
                    this.$message.error(message);
                }
            });
        },
        handleChange(val) {
            this.$emit("input", val);
            this.$emit("change", val);
        },
    },
};
</script>

<style></style>
